module.exports = __webpack_public_path__ + "img/英文版_库尔_河北.7bc46295.webp";